<template>
  <router-view />
</template>

<script setup lang="ts">
// App root — layout is handled per-route via RouterView
</script>
